module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABKklEQVQ4jaXSMUucQRAG4MdwaRQUtNLCyp+gYCciVmdrYRDsrASLs7PV1i6BYGUdBEGvEOy1MCFYJIr+gjRaaSxkZGW/sBzfeWJeWJjZmffdmZ3piwgZPzGIfxddMIAVHKdwo8gZxngPcsImRirnQxHo9XKFp9Jp1CR8wkwX4kbnZSWQyv+Y7VP8qRF4xEO2R0uB1axcCfzFbQf5N+4Lv4VJrCeBNbSxmIMLmO8Q2MFZ4X/DMqaqFpL6EJrYzacOqfTZPO4fL/GIuEi7EBETEdGOiMNsK04jIloRcRkRKxGR9udLRDTLMd7kCr7iAFvoxxy+YwzT2CtHXjfGI5zkj7rCNZbwq66nOoFqEtv4jLsuOS8oW6jDq+S3CPTEfwukP0g7fv4O7jj2nwG9AmLuyDS4VQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/意见反馈.png
// module id = DVUv
// module chunks = 1